<div class="border-container bg-white mb-3">
  <div class="header border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2 title">{{ "Sellers.Products.LegalInfo" | translate }}</h3>
    </div>
  </div>
  <form [formGroup]="legalInfoForm" *ngIf="legalInfoForm">
    <div class="form-group">
      <label>{{ "Sellers.Products.RegisteredBusiness" | translate }}</label>
      <div class="d-block w-100 mt-1">
        <mat-radio-group
          formControlName="hasRegisteredBusiness"
          aria-label="{{ 'Sellers.Products.SelectOption' | translate }}"
        >
          <mat-radio-button
            [value]="true"
            class="me-3"
            (change)="onRadioChange($event)"
          >
            {{ "Sellers.Products.Yes" | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="false" (change)="onRadioChange($event)">
            {{ "Sellers.Products.No" | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <small
        class="text-danger"
        *ngIf="fvlegalInfoForm.formErrors.hasRegisteredBusiness"
      >
        {{ fvlegalInfoForm.formErrors.hasRegisteredBusiness }}
      </small>
    </div>
  </form>
  <ng-container *ngIf="isRegisteredBusiess; else elseTemplate">
    <form [formGroup]="registeredBusinessForm" *ngIf="registeredBusinessForm">
      <div class="row">
        <div class="col-6">
          <div class="form-group mb-3">
            <label>{{
              "Sellers.Products.UploadCommercialRegister" | translate
            }}</label>
            <input
              [formControl]="
                registeredBusinessForm?.controls['commercialRegister']
              "
              (change)="fileChange('commercialRegister', $event)"
              type="file"
              class="form-control-file form-control"
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness?.formErrors?.commercialRegister && !isValid"
            >
              {{ fvRegisteredBusiness.formErrors.commercialRegister }}
            </small>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3 form-group">
            <label>{{ "Sellers.Products.UploadTaxCard" | translate }}</label>
            <input
              [formControl]="registeredBusinessForm?.controls['taxCard']"
              (change)="fileChange('taxCard', $event)"
              type="file"
              class="form-control-file form-control"
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness?.formErrors?.taxCard && !isValid"
            >
              {{ fvRegisteredBusiness.formErrors.taxCard }}
            </small>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-template #elseTemplate>
    <form
      [formGroup]="unRegisteredBusinessForm"
      *ngIf="unRegisteredBusinessForm"
    >
      <div class="row">
        <div class="col-6">
          <div class="mb-3 form-group">
            <label>{{ "Sellers.Products.UploadIDFront" | translate }}</label>
            <input
              [formControl]="
                unRegisteredBusinessForm?.controls['personalIdFront']
              "
              (change)="fileChange('personalIdFront', $event)"
              type="file"
              class="form-control-file form-control"
            />
            <small
              class="text-danger"
              *ngIf="fvUnRegisteredBusiness?.formErrors?.personalIdFront && !isValid"
            >
              {{ fvUnRegisteredBusiness.formErrors.personalIdFront }}
            </small>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3 form-group">
            <label>{{ "Sellers.Products.UploadIDBack" | translate }}</label>
            <input
              [formControl]="
                unRegisteredBusinessForm.controls['personalIdBack']
              "
              (change)="fileChange('personalIdBack', $event)"
              type="file"
              class="form-control-file form-control"
            />
            <small
              class="text-danger"
              *ngIf="fvUnRegisteredBusiness.formErrors?.personalIdBack &&!isValid"
            >
              {{ fvUnRegisteredBusiness?.formErrors.personalIdBack }}
            </small>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</div>
